import 'rc-slider/assets/index.css'
import Big from 'big.js'
import { fromUnit } from 'metronome-utils'
import useTranslation from 'next-translate/useTranslation'
import { useContext } from 'react'
import useSWR from 'swr'

import FiatNumber from './FiatNumber'
import { LockedMETContext } from './LockedMetContext'
import {
  OperationDetailsItem,
  OperationDetailsList,
  OperationDetailsPreviewItem
} from './OperationDetails'

function UnlockFormDetails({
  tokenId,
  amountToUnlock
}: {
  tokenId: number
  amountToUnlock: string
}) {
  const { t } = useTranslation()

  const { metLocker, amountLocked } = useContext(LockedMETContext)

  const { data: calculateExitPenalty = 0 } = useSWR(
    metLocker ? 'lockedmet-calculate-exit-penalty' : null,
    () => metLocker.calculateExitPenalty(tokenId).catch(() => []),
    {
      fallbackData: 0,
      refreshInterval:
        parseInt(process.env.NEXT_PUBLIC_REFRESH_INTERVAL) * 1000,
      revalidateOnMount: true
    }
  )

  const penaltyFee = Big(fromUnit(calculateExitPenalty)).toFixed(4)

  return (
    <div className="bg-blue-secondary rounded-lg p-5">
      <h2 className="mb-4 text-xl text-white">{t('review')}</h2>
      <div className="bg-blue-tertiary rounded-lg">
        <OperationDetailsList>
          <OperationDetailsPreviewItem
            currentAsset="met"
            currentValue={Big(amountLocked).toFixed(4)}
            nextAsset="met"
            nextValue={Big(amountLocked).minus(amountToUnlock).toFixed(4)}
            title={t('amount-locked')}
          />
          <OperationDetailsItem title={t('penalty-fee')}>
            <FiatNumber value={penaltyFee} />
          </OperationDetailsItem>
        </OperationDetailsList>
      </div>
    </div>
  )
}

export default UnlockFormDetails
